import React, { useState } from "react";
import "./FareConditions.css";

function statusTone(label, value) {
  const v = String(value || "").toLowerCase();
  if (v.includes("לא ניתן") || v.includes("לא ניתן להחזר")) return "blocked";
  if (v.includes("בתשלום") || v.includes("מוגבל") || v.includes("חלקי")) return "paid";
  if (v.includes("מותר") || v.includes("כלול")) return "ok";
  if (label.includes("Ticketing") || label.includes("כרטוס")) return "info";
  return "neutral";
}

export default function FareConditions({ conditions }) {
  const [open, setOpen] = useState(false);
  if (!conditions) return null;

  const rows = [
    { label: "שינוי", value: conditions.changes },
    { label: "ביטול", value: conditions.cancellation },
    { label: "החזר", value: conditions.refund },
    { label: "Ticketing", value: conditions.ticketingDeadline },
  ].filter((r) => r.value);

  if (rows.length === 0 && !conditions.fullTerms) return null;

  return (
    <section className="fe2-conds">
      <h2 className="fe2-conds__title">תנאי הכרטיס</h2>
      <ul className="fe2-conds__rows">
        {rows.map((row) => {
          const tone = statusTone(row.label, row.value);
          return (
            <li key={row.label} className="fe2-conds__row">
              <span className="fe2-conds__label">{row.label}</span>
              <span className={`fe2-conds__badge fe2-conds__badge--${tone}`}>
                {row.value}
              </span>
            </li>
          );
        })}
      </ul>
      {conditions.fullTerms ? (
        <>
          <button
            type="button"
            className="fe2-conds__more"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? "הסתר תנאים מלאים" : "צפה בתנאים המלאים"}
          </button>
          {open ? (
            <div className="fe2-conds__drawer">{conditions.fullTerms}</div>
          ) : null}
        </>
      ) : null}
    </section>
  );
}
